import React, { useEffect } from 'react'
import CommonBanner from '../Common/CommonBanner'
import banner from "../../Assets/images/nutzungsbedingungen-banner.webp";
import { useDispatch } from 'react-redux';
import { setHeaderColor, setloading } from '../../Redux/ActionCreater';
const Nutzungsbedingungen = () => {
     let dispatch = useDispatch()
      useEffect(() => {
          dispatch(setHeaderColor("#facee1"));
          window.scrollTo(0, 0);
           dispatch(setloading(false));
        }, [])
  return (
    <div>
      <CommonBanner bannerImage={banner} middleText=""/>
      <section class="toppara impressumcontainer">
        <div class="container">
          <div className="row">
            <div className="col-12">
              <h1>Terms of Service - SHAPE by Sarah App</h1>
              <p>Effective Date: 01.01.2026</p>
              <h3>1. Betreiber der App</h3>
              <p><strong>Die SHAPE by Sarah Harrison („App“) wird betrieben von:</strong></p>
              <p>SHAPE BY SARAH ECOMMERCE - FZCO<br></br>
              Dubai Silicon Oasis,<br></br>
              DDP, Building A1/A2<br></br>
              Dubai, United Arab Emirates<br></br>
              E-Mail: <a href="mailto:support@shapebysarah.com">support@shapebysarah.com</a></p>
              <p><strong>Durch die Nutzung der App erklären Sie sich mit diesen Nutzungsbedingungen einverstanden.</strong></p>
              <h3>2. Zugriff & Nutzung</h3>
              <p><strong>Zugriff: </strong>Die App ist für Personen ab 16 Jahren vorgesehen. Minderjährige dürfen die App nur mit Zustimmung eines Erziehungsberechtigten nutzen.</p>
              <p>Erlaubte Nutzung: Die App darf ausschließlich für private, nicht-kommerzielle Zwecke genutzt werden</p>
              <p>Verbotene Nutzung: Nutzer dürfen die App nicht für rechtswidrige, beleidigende, belästigende oder betrügerische Zwecke verwenden. Insbesondere verboten sind die Verbreitung von Viren oder Schadsoftware, unbefugtes Zugreifen auf andere Nutzerkonten oder Systeme und die Verletzung von Urheberrechten oder Markenrechten.</p>
              <h3>3. Rechte & Pflichten der Nutzer</h3>
              <p>Inhalte, die Nutzer in der App erstellen (z. B. Kommentare, Feedback, Bilder), bleiben grundsätzlich Eigentum der Nutzer.</p>
              <p>Durch das Hochladen räumen die Nutzer SHAPE by Sarah jedoch ein weltweites, nicht-exklusives, lizenzfreies Recht ein, diese Inhalte im Zusammenhang mit der App und den zugehörigen Diensten zu nutzen, zu vervielfältigen, anzuzeigen oder zu verbreiten.</p>
              <p>Nutzer sind verantwortlich für die von ihnen hochgeladenen Inhalte und Handlungen innerhalb der App. SHAPE by Sarah haftet nicht für Schäden, die durch Inhalte oder Verhalten Dritter entstehen.</p>
              <h3>4. Haftungsausschluss</h3>
              <p>Die App wird „wie besehen“ bereitgestellt. SHAPE by Sarah übernimmt keine Garantie für die Richtigkeit, Vollständigkeit oder Verfügbarkeit der Inhalte.</p>
              <p>Nutzung der App erfolgt auf eigenes Risiko. SHAPE by Sarah haftet nicht für direkte oder indirekte Schäden, die aus der Nutzung der App entstehen, soweit gesetzlich zulässig.</p>
              <p>Nutzer werden darauf hingewiesen, dass Workouts und Trainingsinhalte gesundheitliche Risiken bergen können. Nutzer sollten vor der Nutzung ggf. ärztlichen Rat einholen.</p>
              <h3>5. Beendigung / Sperrung</h3>
              <p>SHAPE by Sarah kann den Zugriff eines Nutzers auf die App jederzeit und ohne Vorankündigung sperren oder die Nutzung beenden, insbesondere bei Verstößen gegen diese Nutzungsbedingungen, Gesetzesverstößen oder rechtswidrigem Verhalten sowie bei Störung des App-Betriebs oder der Sicherheit.</p>
              <h3>6. Änderungen der Nutzungsbedingungen</h3>
              <p>SHAPE by Sarah behält sich das Recht vor, diese Nutzungsbedingungen jederzeit zu ändern. Änderungen werden in der App veröffentlicht und gelten ab dem Zeitpunkt der Veröffentlichung. Nutzer sollten die Bedingungen regelmäßig prüfen.</p>
              <h3>7. Anwendbares Recht</h3>
              <p>Diese Nutzungsbedingungen unterliegen dem Recht der Vereinigten Arabischen Emirate.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Nutzungsbedingungen